// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import AnnouncementsList   from './AnnouncementsList';

export default AnnouncementsList;



// WEBPACK FOOTER //
// ./src/app/views/announcements/index.js